"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateGlobalRecurringDateConfigs = void 0;
const formula_engine_1 = require("@finley-technologies/formula-engine");
const validateGlobalRecurringDateConfigs = (params) => {
    const { globalRecurringDateConfigs, options = {} } = params;
    const queryResultVariables = [];
    const errors = [];
    const recurringFieldSet = new Set();
    for (const recurringDateConfig of globalRecurringDateConfigs) {
        const { field, maxCount, setup } = recurringDateConfig;
        // *** Manage query results (no validation occurs here) ***
        // eslint-disable-next-line no-restricted-syntax
        for (let idx = 0; idx < maxCount; idx += 1) {
            queryResultVariables.push(`${field}${(0, formula_engine_1.generateVarIdxSuffix)(idx)}`);
        }
        if (field === '') {
            errors.push('Recurring Date Config field is empty');
            continue;
        }
        if (recurringFieldSet.has(field)) {
            errors.push(`Duplicate recurring date field [${field}]`);
            continue;
        }
        recurringFieldSet.add(field);
        if (maxCount < 1) {
            errors.push(`Max count has to be greater than 0 [input:${maxCount}] [field:${field}]`);
            continue;
        }
        if (!options.ignoreRecurringDateSetupValidate) {
            if (setup.type === 'static') {
                if (setup.config.recurringDateConfigs.length === 0) {
                    errors.push(`Recurring date config setup is empty for [field:${field}]`);
                    continue;
                }
            }
            if (setup.type === 'relative') {
                if (setup.config.relativeRecurringDateConfig.length === 0) {
                    errors.push(`Recurring date config setup is empty for [field:${field}]`);
                    continue;
                }
                if (setup.triggerDateFormula.length === 0) {
                    errors.push(`Recurring date config triggerDateFormula is empty for [field:${field}]`);
                    continue;
                }
            }
        }
    }
    return { queryResultVariables, errors };
};
exports.validateGlobalRecurringDateConfigs = validateGlobalRecurringDateConfigs;
//# sourceMappingURL=validate.js.map